<script lang="ts">
  import { Card, Col, Container, Row } from "sveltestrap";
  import BookmarkBookmarks from "./BookmarkBookmarks.svelte";
  import BookmarkLeft from "./BookmarkLeft.svelte";
  import CreatedByMe from "./CreatedByMe.svelte";
  import Favourites from "./Favourites.svelte";
  import SharedWithMe from "./SharedWithMe.svelte";
  import MyBookmark from "./MyBookmark.svelte";
  import Notification from "./Notification.svelte";
  import Newsletter from "./Newsletter.svelte";

</script>
<BookmarkBookmarks />
<Container fluid>
    <div class="email-wrap bookmark-wrap">
      <Row>
        <BookmarkLeft />
        <Col xl="9" md="12" class="box-col-8 xl-70">
          <div class="email-right-aside bookmark-tabcontent">
            <Card class="email-body radius-left">
              <div class="ps-0">
                  <div class="tab-content">
                    <CreatedByMe />
                    <Favourites />
                    <SharedWithMe />
                    <MyBookmark />
                    <Notification />
                    <Newsletter />
                </div>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
</Container>